var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGreenArrow = function SvgGreenArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.293.707a1,1,0,0,1,1.414,0l4.586,4.586A1,1,0,0,1,11.586,7H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 7)",
    fill: "#01ae3b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreenArrow, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSI3IiB2aWV3Qm94PSIwIDAgMTQgNyI+DQogIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTcpIj4NCiAgICA8cGF0aCBkPSJNNi4yOTMuNzA3YTEsMSwwLDAsMSwxLjQxNCwwbDQuNTg2LDQuNTg2QTEsMSwwLDAsMSwxMS41ODYsN0gyLjQxNGExLDEsMCwwLDEtLjcwNy0xLjcwN1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNykiIGZpbGw9IiMwMWFlM2IiLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { ForwardRef as ReactComponent };